import React from 'react';
import { formatMoney } from '../utils/paymentSummary';

export function PaymentTaxSummary({ summary, className = '' }) {
  if (!summary) return null;

  return (
    <div className={`d-flex flex-column ${className}`.trim()}>
      <span className="text-dark font-weight-bolder font-size-lg">
        Total: {formatMoney(summary.grandTotal)}
      </span>
      <span className="text-muted font-size-sm">
        Tax: {formatMoney(summary.taxTotal)}
      </span>
    </div>
  );
}
